export default __webpack_public_path__ + "static/media/upArrowGreen.d996fbec.svg";